import {cn} from '@/lib/utils' // Replace with your actual utility path
import React from 'react'

interface IMenuToggleProps {
  dir: 'ltr' | 'rtl'
  isProductButtonShow: boolean
  smallScreenToggleButtonRef: React.RefObject<HTMLButtonElement | null>
  setIsProductButtonShow: React.Dispatch<React.SetStateAction<boolean>>
  setDropdownOpen: React.Dispatch<React.SetStateAction<boolean>>
}

export const SmallScreenToggleMenu: React.FC<IMenuToggleProps> = ({
  dir,
  isProductButtonShow,
  smallScreenToggleButtonRef,
  setIsProductButtonShow,
  setDropdownOpen,
}) => {
  const toggleMenu = (): void => {
    setIsProductButtonShow(prev => !prev)
    if (isProductButtonShow) {
      setDropdownOpen(false)
    }
  }
  return (
    <button
      className={cn(
        'relative w-10 h-10 flex flex-col justify-center items-center',
        dir === 'rtl' ? 'mr-4' : 'ml-4',
      )}
      onClick={toggleMenu}
      ref={smallScreenToggleButtonRef}
      aria-label="menu-toggle-btn"
    >
      <span
        className={`absolute w-6 h-[3px] bg-white transition-transform duration-300 ${
          isProductButtonShow ? 'rotate-45 translate-y-0' : '-translate-y-2.5'
        }`}
      />
      <span
        className={`absolute w-6 h-[3px] bg-white transition-opacity duration-300 ${
          isProductButtonShow ? 'opacity-0' : 'opacity-100'
        }`}
      />
      <span
        className={`absolute w-6 h-[3px] bg-white transition-transform duration-300 ${
          isProductButtonShow ? '-rotate-45 translate-y-0' : 'translate-y-2.5'
        }`}
      />
    </button>
  )
}
